import React, { useEffect, useState } from "react";
import style from "./style.module.scss";
import { useAppDispatch, useAppSelector } from "../../../../../../store";
import { Form, Formik } from "formik";
import {
  AdminDetailsPageItemName,
  Button,
  TextArea,
} from "../../../../../../components";
import appConfig from "../../../../../../util/appConfig";
import removeIcon from "../../../../../../assets/images/removeIcon.svg";
import {
  updateHintsText,
  getHintsText,
  FormType,
  HintItem,
} from "../../../../../../store/slices/app";
import checkMark from "../../../../../../assets/images/checkMark.svg";

const formTabs = {
  awl: ["Sperrmüll"],
  ebwo: ["Sperrmüll"],
  lra: [
    "Sperrmüll",
    "Objektverwaltung",
    "Reklamation",
    "Zusatzleistungen",
    "SEPA",
    "Eigentümerwechsel",
  ],
};

// const getStepsForForm = (env: string, formType: string): number[] => {
//   // Sperrmüll has 3 steps for all environments
//   if (formType === "Sperrmüll") {
//     return [1, 2, 3];
//   }
//   // All other forms have 2 steps by default
//   return [1, 2];
// };

const InfoText = () => {
  const dispatch = useAppDispatch();
  const { hints } = useAppSelector((state) => state.app.client);

  const [state, setState] = useState<{
    [FormType.Sperrmuell]: HintItem[];
    [FormType.Objektverwaltung]: HintItem[];
    [FormType.Reklamation]: HintItem[];
    [FormType.Zusatzleistungen]: HintItem[];
    [FormType.SEPA]: HintItem[];
    [FormType.Eigentuemerwechsel]: HintItem[];
  }>({
    Eigentümerwechsel: [],
    Objektverwaltung: [],
    Reklamation: [],
    SEPA: [],
    Sperrmüll: [],
    Zusatzleistungen: [],
  });
  const generateTabs = (env: string): string[] => {
    return formTabs[env as keyof typeof formTabs] || [];
  };

  const [activeTab, setActiveTab] = useState<string>(
    generateTabs(appConfig.logo)[0] || ""
  );
  const initialValues = {
    state,
  };

  useEffect(() => {
    let obj: any = {};

    // const currentSteps = getStepsForForm(appConfig.logo, activeTab);
    // const currentSteps: number[] = [];
    // currentSteps.forEach((el) => {
    //   obj[el] = [];
    // });

    // for (const key in obj) {
    //   const item = infoText.find(
    //     (el) => el.step === +key && el.formType === activeTab
    //   );
    //   if (item) {
    //     obj[key] = {
    //       steps: [...item.hints],
    //       isWarningMessage: item?.isWarningMessage || false,
    //     };
    //   } else {
    //     obj[key] = {
    //       steps: [],
    //       isWarningMessage: false,
    //     };
    //   }
    // }
    // setState(obj);
    if (hints) {
      const keys = Object.keys(hints) as FormType[];
      keys.forEach((key) => {
        setState((prev) => {
          return { ...prev, [key]: hints[key] ?? [] };
        });
      });
    }
  }, [hints, activeTab]);

  useEffect(() => {
    dispatch(getHintsText());
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={({ state }) => {
        const cleanedObj: Record<string, HintItem[]> = {};

        const keys = Object.keys(state);

        keys.forEach((key) => {
          if (state[key as FormType].length) {
            cleanedObj[key] = state[key as FormType];
          }
        });

        dispatch(updateHintsText(cleanedObj));
      }}
      enableReinitialize
    >
      {({ values, setFieldValue }) => {
        return (
          <>
            <AdminDetailsPageItemName text="Hinweisstexte" />
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {generateTabs(appConfig.logo).map((el) => {
                return (
                  <div
                    key={el}
                    style={{
                      fontFamily: "Nunito",
                      fontWeight: 700,
                      fontSize: "16px",
                      color: el === activeTab ? "#353b3f" : "#8f9ea9",
                      cursor: "pointer",
                      padding: "10px 20px",
                    }}
                    onClick={() => setActiveTab(el)}
                  >
                    {el}
                  </div>
                );
              })}
            </div>
            <Form>
              <div
                style={{
                  marginBottom: "100px",
                }}
              >
                {values.state[activeTab as FormType]
                  // .sort((a, b) => a.step - b.step)
                  .map((el, idx) => {
                    return (
                      <div key={`step-${idx}`}>
                        <div className={style.label}>Schritt {el.step}</div>
                        {activeTab === "Sperrmüll" ? (
                          <div className={style.checkboxContentWrapper}>
                            <input
                              type="checkbox"
                              name={`state[${activeTab}][${idx}].isWarningMessage`}
                              value={`state[${activeTab}][${idx}].isWarningMessage`}
                              checked={
                                values.state[activeTab as FormType][idx]
                                  .isWarningMessage
                              }
                              style={{
                                display: "none",
                              }}
                              onChange={() => {}}
                            />
                            <div
                              style={{
                                display: "flex",
                              }}
                            >
                              <div
                                onClick={() => {
                                  setFieldValue(
                                    `state[${activeTab}][${idx}].isWarningMessage`,
                                    !values.state[activeTab as FormType][idx]
                                      .isWarningMessage
                                  );
                                }}
                                className={`${style.checkBox} ${
                                  values.state[activeTab as FormType][idx]
                                    .isWarningMessage
                                    ? style.checkBox_checked
                                    : ""
                                }`}
                              >
                                {values.state[activeTab as FormType][idx]
                                  .isWarningMessage && (
                                  <img
                                    className={style.checkedImg}
                                    src={checkMark}
                                    alt="check"
                                  />
                                )}
                              </div>
                              <span
                                className={`${style.title} ${
                                  values.state[activeTab as FormType][idx]
                                    .isWarningMessage
                                    ? style.checkboxTitle
                                    : ""
                                }`}
                                onClick={() => {
                                  setFieldValue(
                                    `state[${activeTab}][${idx}].isWarningMessage`,
                                    !values.state[activeTab as FormType][idx]
                                      .isWarningMessage
                                  );
                                }}
                              >
                                Mit wichtigen Mitteilungen (wird rot
                                geschrieben)
                              </span>
                            </div>
                          </div>
                        ) : null}
                        {values.state[activeTab as FormType][idx] ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                              marginBottom: "10px",
                            }}
                          >
                            {values.state[activeTab as FormType][
                              idx
                            ]?.hints.map((el: string, id: number) => {
                              return (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  key={id}
                                >
                                  <TextArea
                                    name={`state[${activeTab}][${idx}].hints[${id}]`}
                                    type="text"
                                  />
                                  <img
                                    src={removeIcon}
                                    style={{
                                      marginLeft: "20px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      const path =
                                        `state.[${activeTab}].${idx}.hints` as const;
                                      const currentHints =
                                        values.state[activeTab as FormType][idx]
                                          .hints;
                                      const newHints = currentHints.filter(
                                        (_, i) => i !== id
                                      );
                                      setFieldValue(path, newHints);
                                    }}
                                    alt="removeIcon"
                                  />
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                        <div
                          className={style.addHint}
                          onClick={() => {
                            setFieldValue(`state[${activeTab}][${idx}].hints`, [
                              ...values.state[activeTab as FormType][idx].hints,
                              "",
                            ]);
                          }}
                        >
                          + Hinweisstext zufügen
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: "32px",
                }}
              >
                <Button
                  width="200"
                  textColor="#fff"
                  backgroundColor="#008BD2"
                  text="Speichern"
                  type="button"
                  isOutlined
                  onClick={() => {
                    const length = values.state[activeTab as FormType]?.length;
                    setFieldValue("state", {
                      ...values.state,
                      [activeTab]: [
                        ...values.state[activeTab as FormType],
                        {
                          step: typeof length === "number" ? length + 1 : 0,
                          hints: [],
                          isWarningMessage: false,
                        },
                      ],
                    });
                  }}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  width="200"
                  textColor="#fff"
                  backgroundColor="#008BD2"
                  text="Speichern"
                  type="submit"
                />
              </div>
            </Form>
          </>
        );
      }}
    </Formik>
  );
};

export default InfoText;

// {Object.keys(values.steps).map((step, idx) => {
//                   return (
//                     <div key={`${step}-${idx}`}>
//                       <div className={style.label}>Schritt {idx + 1}</div>
//                       <div className={style.checkboxContentWrapper}>
//                         <input
//                           type="checkbox"
//                           name={`steps[${step}].isWarningMessage`}
//                           value={`steps[${step}].isWarningMessage`}
//                           checked={values.steps[step].isWarningMessage}
//                           style={{
//                             display: "none",
//                           }}
//                           onChange={() => {}}
//                         />
//                         <div
//                           style={{
//                             display: "flex",
//                           }}
//                         >
//                           <div
//                             onClick={() => {
//                               setFieldValue(
//                                 `steps[${step}].isWarningMessage`,
//                                 !values.steps[step].isWarningMessage
//                               );
//                             }}
//                             className={`${style.checkBox} ${
//                               values.steps[step].isWarningMessage
//                                 ? style.checkBox_checked
//                                 : ""
//                             }`}
//                           >
//                             {values.steps[step].isWarningMessage && (
//                               <img
//                                 className={style.checkedImg}
//                                 src={checkMark}
//                                 alt="check"
//                               />
//                             )}
//                           </div>
//                           <span
//                             className={`${style.title} ${
//                               values.steps[step].isWarningMessage
//                                 ? style.checkboxTitle
//                                 : ""
//                             }`}
//                             onClick={() => {
//                               setFieldValue(
//                                 `steps[${step}].isWarningMessage`,
//                                 !values.steps[step].isWarningMessage
//                               );
//                             }}
//                           >
//                             Mit wichtigen Mitteilungen (wird rot geschrieben)
//                           </span>
//                         </div>
//                       </div>
//                       {values.steps[step].steps?.length ? (
//                         <div
//                           style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             gap: "10px",
//                             marginBottom: "10px",
//                           }}
//                         >
//                           {values.steps[step].steps.map(
//                             (el: string, id: number) => {
//                               return (
//                                 <div
//                                   style={{
//                                     display: "flex",
//                                     alignItems: "center",
//                                   }}
//                                   key={id}
//                                 >
//                                   <TextArea
//                                     name={`steps[${step}].steps.[${id}]`}
//                                     type="text"
//                                   />
//                                   <img
//                                     src={removeIcon}
//                                     style={{
//                                       marginLeft: "20px",
//                                     }}
//                                     onClick={() => {
//                                       values.steps[step].steps.splice(id, 1);
//                                       setFieldValue(`steps[${step}].steps`, [
//                                         ...values.steps[step].steps,
//                                       ]);
//                                     }}
//                                     alt="removeIcon"
//                                   />
//                                 </div>
//                               );
//                             }
//                           )}
//                         </div>
//                       ) : null}
//                       <div
//                         className={style.addHint}
//                         onClick={() => {
//                           setFieldValue(`steps[${step}].steps`, [
//                             ...values.steps[step].steps,
//                             "",
//                           ]);
//                         }}
//                       >
//                         + Hinweisstext zufügen
//                       </div>
//                     </div>
//                   );
//                 })}
